import React, { useEffect } from "react"
import { useSelector, useDispatch } from "react-redux"
import { useNavigate } from "react-router-dom"
import { removeWishlist, getWishlist } from "../../store"
import "../styles/WishlistPage.css"

function WishlistPage() {
  const { wishlist } = useSelector((state) => state.products)
  const { id } = useSelector((state) => state.auth)

  const dispatch = useDispatch()
  const navigate = useNavigate()

  const handleRemove = (productId) => {
    if (
      window.confirm(
        "Are you sure you want to remove this product from your wishlist?"
      )
    ) {
      dispatch(removeWishlist(productId))
        .then(() => {
          console.log("Product removed from wishlist successfully")
          dispatch(getWishlist(id)) // Refresh the wishlist
        })
        .catch((error) => {
          console.error("Error removing product from wishlist:", error)
        })
    }
  }

  useEffect(() => {
    dispatch(getWishlist(id))
  }, [])

  return (
    <div className="wishlist-page-container">
      <h1 className="wishlist-page-title">Wish List</h1>
      <table className="wishlist-table">
        <thead>
          <tr>
            <th>Product</th>
            <th>Description | Category</th>
            <th>Price</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {wishlist.length > 0 &&
            wishlist.map((product) => {
              if (!product.product) return null
              return (
                <tr key={product.productId}>
                  <td>
                    <div className="product-info">
                      <div className="product-avatar">
                        <div className="product-mask">
                          <img
                            src={product.product.imageURL}
                            alt={product.product.name}
                            loading="lazy"
                          />
                        </div>
                      </div>

                      <div>
                        <div className="product-name">
                          {product.product.name}
                        </div>
                        <div className="product-material">
                          {product.product.material}
                        </div>
                      </div>
                    </div>
                  </td>
                  <td>
                    <span className="product-description">
                      {product.product.description}
                    </span>
                    <br />
                    <span className="product-category">
                      {product.product.category}
                    </span>
                  </td>
                  <td className="product-price">${product.product.price}</td>
                  <th>
                    <div className="product-actions">
                      <button
                        className="view-button"
                        onClick={() => {
                          navigate(`/products/${product.productId}`)
                        }}
                      >
                        View
                      </button>
                      <button
                        className="delete-button"
                        onClick={() => {
                          handleRemove(product.productId)
                        }}
                      >
                        <svg className="delete-svgIcon" viewBox="0 0 448 512">
                          <path d="M135.2 17.7L128 32H32C14.3 32 0 46.3 0 64S14.3 96 32 96H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H320l-7.2-14.3C307.4 6.8 296.3 0 284.2 0H163.8c-12.1 0-23.2 6.8-28.6 17.7zM416 128H32L53.2 467c1.6 25.3 22.6 45 47.9 45H346.9c25.3 0 46.3-19.7 47.9-45L416 128z"></path>
                        </svg>
                      </button>
                    </div>
                  </th>
                </tr>
              )
            })}
        </tbody>
      </table>
    </div>
  )
}

export default WishlistPage
